/** Enum representing the types of correction reasons. */
export enum CorrectionReasonType {
  WRONG_IMPLEMENTATION = 'wrong_implementation',
  SUBSEQUENT_CHANGE = 'subsequent_change',
  NEW_INFORMATION = 'new_info',
  ORDER_DEVIATIONS = 'order_deviations',
}

/**
 * Billing fields of a floor plan correction request.
 *
 * The billing product is identified by its Product2 code alone. A legacy numeric id, or a blank
 * code, is rejected by the API.
 */
export interface GrundrissSchmiedeOrderCorrectionBillingDTO {
  /** The ID of the payment intent, for subsequent change correction type. */
  paymentIntentId?: string
  /** Product2 code of the billing product, absent when the correction needs no payment. */
  primaryBillingProductCode?: string
}

/** DTO representing a correction order for GrundrissSchmiede orders (also known as floor plan certificate). */
export interface GrundrissSchmiedeOrderCorrectionDTO extends GrundrissSchmiedeOrderCorrectionBillingDTO {
  /** The correctionReference of the document that needs to be corrected, as returned by the documents listing. Identifies the delivered unit directly, so it also works for documents stored under a name that differs from the one they were delivered under. */
  correctionReference?: string
  /** The name of the file that needs to be corrected. Only used when correctionReference is absent. */
  fileNameToCorrect: string
  /** The message describing the correction details. */
  message: string
  /** The filename of the correction template to be used. */
  correctionTemplateFileName: string
  /** The reason for the correction. */
  correctionReason: CorrectionReasonType
}
